module.exports = __webpack_public_path__ + "static/media/YM25_2.c63b85a0.jpg";